
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  public _baseurl = environment.baseUrl;
  public _url = environment.apiUrl;
  public _imgurl = environment.imgUrl;
  public _feeServiceurl = environment.feeServiceBaseUrl;
  public _libraryManagementUrl = environment.libraryManagementBaseUrl;
  public _gdsBaseUrl = environment.gdsBaseUrl;
  public _eStoreBaseUrl=environment.eStoreBaseUrl;
  public _hrmsBaseUrl=environment.hrmsBaseUrl+'/';
  public _misApiUrl = environment.misApiUrl;
  public _governanceApiUrl = environment.governanceApiUrl;

  constructor() { }
}

